export const LEAVE_TYPES_STRINGS = {
  TITLE: "Tipos de Permisos",

  TEXT_TABLE_RESULTS:
    "Mostrando {first} a {last} de {totalRecords} tipos de permisos",

  TEXT_TOOLTIP_EDIT: "Editar tipo de permiso",
  TEXT_TOOLTIP_DELETE: "Eliminar tipo de permiso",

  EXPORT_NO_DATA: "No hay tipos de permisos para exportar a Excel.",
  EXPORT_SUCCESS:
    "Los tipos de permisos se han exportado a Excel correctamente.",
  EXPORT_ERROR:
    "Error al exportar los tipos de permisos a Excel. Por favor, intente nuevamente.",

  DIALOG_TITLE_NEW: "Nuevo permiso",
  DIALOG_TITLE_EDIT: "Editar permiso",
  BUTTON_CANCEL: "Cancelar",
  BUTTON_DELETE: "Eliminar",
  DELETE_CONFIRM_MESSAGE: "¿Está seguro de eliminar este tipo de permiso? Esta acción no se puede deshacer.",
  BUTTON_BACK: "Regresar",
  BUTTON_CONTINUE: "Continuar",
  BUTTON_SAVE: "Guardar",
  DAYS_TEXT: "días",

  // Step 1
  IS_JUSTIFIED_LABEL: "¿Este permiso justificará faltas o retardos?",
  IS_JUSTIFIED_YES: "Sí, este permiso justifica faltas o retardos",
  IS_JUSTIFIED_NO: "No, no justifica faltas ni retardos",
  CODE_LABEL: "Clave",
  CODE_PLACEHOLDER: "Ej: PERM_PAT_02",
  NAME_LABEL: "Nombre",
  NAME_PLACEHOLDER: "Ej: Paternidad/Adopción paterna",
  INCIDENCE_TYPE_LABEL: "Tipo de incidencia",
  INCIDENCE_TYPE_PLACEHOLDER: "Selecciona una opción",
  SELECT_ICON_LABEL: "Selecciona un ícono",

  // Step 2
  APPROVAL_FLOW_LABEL: "¿Cómo se aprobará este permiso?",
  APPROVAL_FLOW_PLACEHOLDER: "Selecciona una opción",
  HAS_BALANCE_CONTROL_LABEL: "¿Tiene control de saldos?",
  HAS_BALANCE_CONTROL_YES: "Sí",
  HAS_BALANCE_CONTROL_NO: "No",
  ANNUAL_DAYS_LABEL: "Máximo de días permitidos por año",
  ANNUAL_DAYS_PLACEHOLDER: "Ej: 10",
  MAX_DAYS_PER_REQUEST_LABEL: "Máximo de días por cada solicitud",
  MAX_DAYS_PER_REQUEST_PLACEHOLDER: "Ej: 1",
  RESET_MONTH_LABEL: "Mes en que se reinicia el conteo anual",
  RESET_MONTH_HELPER: "A partir de qué mes se reinicia el saldo disponible",
  REQUIRES_ATTACHMENT_LABEL: "¿Requiere subir evidencia obligatoria?",
  REQUIRES_ATTACHMENT_YES: "Sí, es obligatorio adjuntar evidencia",
  REQUIRES_ATTACHMENT_NO: "No es obligatorio adjuntar evidencia",
  HEADER_DEADLINE_TO_REQUEST: "Plazo para solicitar el permiso",
  ADVANCE_NOTICE_LABEL: "Fechas futuras",
  RADIO_ADVANCE_NOTICE_NONE: "Sin anticipación mínima",
  RADIO_ADVANCE_NOTICE_REQUIRED: "Requiere solicitarse con anticipación",
  INPUT_ADVANCE_NOTICE_LABEL: "Con al menos",
  INPUT_ADVANCE_NOTICE_PLACEHOLDER: "Ej. 5",
  INPUT_ADVANCE_NOTICE_HELPER: "Mínimo 1 y máximo 15 días",
  ALLOW_BACKDATE_LABEL: "Fechas pasadas",
  RADIO_PAST_DATES_NO: "No se pueden registrar fechas pasadas",
  RADIO_PAST_DATES_YES: "Se pueden registrar fechas pasadas",
  INPUT_PAST_DATES_LABEL: "Desde hoy hasta",
  INPUT_PAST_DATES_PLACEHOLDER: "Ej. 5",
  INPUT_PAST_DATES_HELPER: "Mínimo 1 y máximo 15 días",

  INCIDENCE_TYPES_ERROR: "Error al obtener los tipos de incidencia",

  TYPES_ERROR_MESSAGE: "Error al cargar los tipos de permiso.",

  CREATE_SUCCESS: "El tipo de permiso se creó correctamente.",
  CREATE_PARTIAL_FAILURE: "El tipo de permiso no pudo crearse.",
  CREATE_ERROR: "Error al crear el tipo de permiso. Por favor, intente nuevamente.",

  UPDATE_SUCCESS: "El tipo de permiso se actualizó correctamente.",
  UPDATE_ERROR: "Error al actualizar el tipo de permiso. Por favor, intente nuevamente.",

  DELETE_SUCCESS: "El tipo de permiso se eliminó correctamente.",
  DELETE_PARTIAL_FAILURE: "Algunos tipos de permiso no pudieron eliminarse.",
  DELETE_ERROR: "Error al eliminar el tipo de permiso. Por favor, intente nuevamente.",

  TOGGLE_ACTIVE_STATUS_ERROR: "Error al actualizar el estado del tipo de permiso. Por favor, intente nuevamente.",
} as const;
